import type { FC } from "react";
import { Stack } from "@certa/catalyst/layouts/Stack";
import {
  TypographyColors,
  TypographyVariants,
  Typography
} from "@certa/catalyst/components/Typography";
import { css } from "emotion";
import { classNames } from "@certa/catalyst/utils/common";

export const NoComments: FC<{
  text: string;
  isMultiChannel?: boolean;
}> = ({ text, isMultiChannel }) => {
  return (
    <Stack
      direction="vertical"
      align="center"
      justify="center"
      gap="8"
      dangerouslySetClassName={classNames({
        [noCommentsWrapperStyles]: true,
        [marginBottomStyles]: !isMultiChannel
      })}
    >
      <Typography
        variant={TypographyVariants.BODY}
        color={TypographyColors.NEUTRAL_700}
      >
        {text}
      </Typography>
    </Stack>
  );
};

const noCommentsWrapperStyles = css({
  width: "100%",
  height: "100%"
});

const marginBottomStyles = css({
  marginBottom: "var(--space-16)"
});
